import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { VerifyAccountComponent } from './verify-account.component';
import { SharedModule } from 'src/app/modules/shared/shared.module';

@NgModule({
    declarations: [
        VerifyAccountComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule
    ],
    providers: []
})
export class VerifyAccountModule {
}
